import { render, staticRenderFns } from "./SettingEditLayout.vue?vue&type=template&id=1337053c&scoped=true&"
import script from "./SettingEditLayout.vue?vue&type=script&lang=js&"
export * from "./SettingEditLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingEditLayout.vue?vue&type=style&index=0&id=1337053c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337053c",
  null
  
)

export default component.exports